module.exports = __webpack_public_path__ + "static/media/9.37b728ac.jpg";